import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import { Observable, from, of } from "rxjs";
import { BaseEntity } from "../entities/BaseEntities";
import { BaseDataStoreAbstract } from "./BaseDataStoreAbstract";

export abstract class BaseDataSourceAbstract
{
    private m_DataSource: DataSource;

    constructor(private m_DataStore: BaseDataStoreAbstract, customOptions?:any)
    {
        
        this.m_DataSource = new DataSource(
            {
                ...
                {
                    store: m_DataStore.Store,
                    pageSize: 30
                },
                ...
                customOptions
            });
    }

    public get IsLoaded(): boolean {
        return this.m_DataSource.isLoaded();
    }

    public get Data(): DataSource
    {
        return this.m_DataSource;
    }

    public get Store(): CustomStore
    {
        return this.m_DataStore.Store;
    }

    public get Items(): any[]
    {
        if (!this.IsLoaded) this.m_DataSource.load();
        return this.m_DataSource.items();
    }

    public GetItemsAsync(): Observable<any[]>
    {
        this.m_DataSource.paginate(false);
        if (!this.IsLoaded) return from(this.m_DataSource.load().then(items => items));
        return of(this.m_DataSource.items());
    }

    public FindAsync<TEntity extends BaseEntity>(Key: any): Observable<TEntity>
    {
        if (Key == null || Key == undefined) 
        {
            console.error("Trying to find an empty key");
        };
        return from(this.Store.byKey(Key));
    }

    //Performs synchronous search on the datasource. Can be used only with raw datasources that has already been loaded
    public Find<TEntity extends BaseEntity>(Key: any): TEntity
    {
        return (this.Data.items() as TEntity[]).find(x => x.EntryID == Key);
    }

    public GetCount(): Observable<number>
    {
        return from(this.Store.totalCount(undefined));
    }

    public Reload() : Observable<any>
    {
        return from(this.Data.reload());
    }

    public AddEventListener(eventName: string, action: (e?: any) => void) {
        this.m_DataSource.on(eventName as any, action);
    }
}
